import { ArrowLeft, Calendar, Car, Clock, MapPin, Plane, Printer, Train, TramFront } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { EVENTS, VENUE_NAME, VENUE_ADDRESS, TRAVEL_TIMES, HASHTAG, mapsLink } from "@/lib/wedding-data";

const TRAVEL_ICONS = { plane: Plane, car: Car, train: Train, metro: TramFront };

export default function DirectionsCard() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] py-10 px-4 flex flex-col items-center">
      <div className="no-print mb-8 flex flex-wrap justify-center gap-4">
        <a
          href="/"
          data-testid="card-back-link"
          className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/50 text-[#5D171E] text-xs uppercase tracking-[0.2em] px-6 py-3 hover:border-[#5D171E] transition-colors duration-300"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> Back to Invitation
        </a>
        <button
          onClick={() => window.print()}
          data-testid="card-print-button"
          className="inline-flex items-center gap-2 rounded-full bg-[#5D171E] text-[#FDFBF7] text-xs uppercase tracking-[0.2em] px-6 py-3 hover:bg-[#471016] transition-colors duration-300"
        >
          <Printer className="h-3.5 w-3.5" /> Save / Print
        </button>
      </div>

      <div
        data-testid="directions-card"
        className="print-card gold-frame w-full max-w-md rounded-3xl bg-white border border-[#D4AF37]/40 overflow-hidden"
      >
        <div className="bg-[#5D171E] text-[#FDFBF7] px-8 py-8 text-center">
          <p className="text-[10px] uppercase tracking-[0.35em] text-[#E1C699]">
            Wedding Weekend · Directions & Schedule
          </p>
          <h1 className="mt-3 font-serif text-3xl tracking-tight">
            Vishi <span className="italic text-[#E1C699]">&</span> Piyush
          </h1>
          <p className="mt-2 text-xs uppercase tracking-[0.2em] text-[#FDFBF7]/70">
            January 22 - 24, 2027
          </p>
        </div>

        <div className="px-8 py-6 border-b border-[#D4AF37]/25 flex items-center gap-5">
          <div className="flex-1">
            <p className="flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-[#5D171E]/70">
              <MapPin className="h-3.5 w-3.5" /> The Venue
            </p>
            <p className="mt-2 font-serif text-xl text-[#1A1A1A]">{VENUE_NAME}</p>
            <p className="mt-1 text-xs text-[#1A1A1A]/60 leading-relaxed">
              {VENUE_ADDRESS}
            </p>
            <p className="mt-2 text-[10px] uppercase tracking-[0.2em] text-[#D4AF37]">
              Scan for directions
            </p>
          </div>
          <div className="shrink-0 rounded-xl border border-[#D4AF37]/40 p-2 bg-white">
            <QRCodeSVG value={mapsLink(VENUE_ADDRESS)} size={88} fgColor="#5D171E" />
          </div>
        </div>

        <div className="px-8 py-6 border-b border-[#D4AF37]/25">
          <p className="flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-[#5D171E]/70 mb-4">
            <Calendar className="h-3.5 w-3.5" /> The Schedule
          </p>
          <div className="space-y-3">
            {EVENTS.map((ev) => (
              <div key={ev.key} className="flex items-baseline justify-between gap-4">
                <div>
                  <p className="font-serif text-base text-[#1A1A1A]">{ev.name}</p>
                  <p className="text-[10px] uppercase tracking-[0.15em] text-[#1A1A1A]/50">
                    {ev.date}
                  </p>
                </div>
                <p className="text-xs text-[#5D171E] whitespace-nowrap flex items-center gap-1.5">
                  <Clock className="h-3 w-3 text-[#D4AF37]" />
                  {ev.time.replace(" onwards", "")}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="px-8 py-6 border-b border-[#D4AF37]/25">
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#5D171E]/70 mb-4">
            Getting Here
          </p>
          <div className="space-y-2.5">
            {TRAVEL_TIMES.slice(0, 3).map((t) => {
              const Icon = TRAVEL_ICONS[t.icon];
              return (
                <div key={t.label} className="flex items-center gap-3">
                  <Icon className="h-3.5 w-3.5 text-[#D4AF37] shrink-0" />
                  <p className="flex-1 text-xs text-[#1A1A1A]/70">{t.label}</p>
                  <p className="text-xs font-medium text-[#5D171E]">{t.time}</p>
                </div>
              );
            })}
          </div>
        </div>

        <p className="px-8 py-5 text-center font-serif italic text-lg text-[#5D171E]">
          {HASHTAG}
        </p>
      </div>
    </div>
  );
}
